"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoginOrGoToAuthServer = createLoginOrGoToAuthServer;
var toFullyQualifiedUrl_1 = require("../tools/toFullyQualifiedUrl");
var tsafe_1 = require("../vendor/frontend/tsafe");
var GLOBAL_CONTEXT_KEY = "__oidc-spa.loginOrGoToAuthSever.globalContext";
(_a = window[GLOBAL_CONTEXT_KEY]) !== null && _a !== void 0 ? _a : (window[GLOBAL_CONTEXT_KEY] = {
    hasLoginBeenCalled: false,
    URL_real: window.URL
});
var globalContext = window[GLOBAL_CONTEXT_KEY];
function createLoginOrGoToAuthServer(params) {
    var configId = params.configId, oidcClientTsUserManager = params.oidcClientTsUserManager, getExtraQueryParams = params.getExtraQueryParams, transformUrlBeforeRedirect = params.transformUrlBeforeRedirect, homeAndCallbackUrl = params.homeAndCallbackUrl, log = params.log;
    var LOCAL_STORAGE_KEY_TO_CLEAR_WHEN_RETURNING_OIDC_LOGGED_IN = "oidc-spa.login-redirect-initiated:".concat(configId);
    var lastPublicUrl = undefined;
    function loginOrGoToAuthServer(params) {
        return __awaiter(this, void 0, void 0, function () {
            var redirectUrl_params, extraQueryParams_local, transformUrlBeforeRedirect_local, rest, callback_1, redirectUrl, transformUrl_oidcClientTs, redirectMethod, extraQueryParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        redirectUrl_params = params.redirectUrl, extraQueryParams_local = params.extraQueryParams_local, transformUrlBeforeRedirect_local = params.transformUrlBeforeRedirect_local, rest = __rest(params, ["redirectUrl", "extraQueryParams_local", "transformUrlBeforeRedirect_local"]);
                        log === null || log === void 0 ? void 0 : log("Calling loginOrGoToAuthServer", { params: params });
                        login_specific_handling: {
                            if (rest.action !== "login") {
                                break login_specific_handling;
                            }
                            if (globalContext.hasLoginBeenCalled) {
                                log === null || log === void 0 ? void 0 : log("login() has already been called, ignoring the call");
                                return [2 /*return*/, new Promise(function () { })];
                            }
                            globalContext.hasLoginBeenCalled = true;
                            bf_cache_handling: {
                                if (rest.doForceReloadOnBfCache) {
                                    document.removeEventListener("visibilitychange", function () {
                                        if (document.visibilityState === "visible") {
                                            location.reload();
                                        }
                                    });
                                    break bf_cache_handling;
                                }
                                localStorage.setItem(LOCAL_STORAGE_KEY_TO_CLEAR_WHEN_RETURNING_OIDC_LOGGED_IN, "true");
                                callback_1 = function () {
                                    if (document.visibilityState === "visible") {
                                        document.removeEventListener("visibilitychange", callback_1);
                                        log === null || log === void 0 ? void 0 : log("We came back from the login pages and the state of the app has been restored");
                                        if (rest.doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack) {
                                            if (lastPublicUrl !== undefined) {
                                                log === null || log === void 0 ? void 0 : log("Loading last public route: ".concat(lastPublicUrl));
                                                window.location.href = lastPublicUrl;
                                            }
                                            else {
                                                log === null || log === void 0 ? void 0 : log("We don't know the last public route, navigating back in history");
                                                window.history.back();
                                            }
                                        }
                                        else {
                                            log === null || log === void 0 ? void 0 : log("The current page doesn't require auth...");
                                            if (localStorage.getItem(LOCAL_STORAGE_KEY_TO_CLEAR_WHEN_RETURNING_OIDC_LOGGED_IN) === null) {
                                                log === null || log === void 0 ? void 0 : log("but the user is now authenticated, reloading the page");
                                                location.reload();
                                            }
                                            else {
                                                log === null || log === void 0 ? void 0 : log("and the user doesn't seem to be authenticated, avoiding a reload");
                                                globalContext.hasLoginBeenCalled = false;
                                            }
                                        }
                                    }
                                };
                                log === null || log === void 0 ? void 0 : log("Start listening to visibility change event");
                                document.addEventListener("visibilitychange", callback_1);
                            }
                        }
                        redirectUrl = (0, toFullyQualifiedUrl_1.toFullyQualifiedUrl)({
                            urlish: redirectUrl_params,
                            doAssertNoQueryParams: false
                        });
                        log === null || log === void 0 ? void 0 : log("redirectUrl: ".concat(redirectUrl));
                        transformUrl_oidcClientTs = function (url) {
                            [
                                [getExtraQueryParams === null || getExtraQueryParams === void 0 ? void 0 : getExtraQueryParams(), transformUrlBeforeRedirect],
                                [extraQueryParams_local, transformUrlBeforeRedirect_local]
                            ].forEach(function (_a) {
                                var e_1, _b;
                                var _c = __read(_a, 2), extraQueryParams = _c[0], transformUrlBeforeRedirect = _c[1];
                                add_extra_query_params: {
                                    if (extraQueryParams === undefined) {
                                        break add_extra_query_params;
                                    }
                                    var url_obj = new URL(url);
                                    try {
                                        for (var _d = __values(Object.entries(extraQueryParams)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                            var _f = __read(_e.value, 2), name_1 = _f[0], value = _f[1];
                                            url_obj.searchParams.set(name_1, value);
                                        }
                                    }
                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                    finally {
                                        try {
                                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                    }
                                    url = url_obj.href;
                                }
                                apply_transform_before_redirect: {
                                    if (transformUrlBeforeRedirect === undefined) {
                                        break apply_transform_before_redirect;
                                    }
                                    url = transformUrlBeforeRedirect(url);
                                }
                            });
                            return url;
                        };
                        redirectMethod = (function () {
                            switch (rest.action) {
                                case "login":
                                    return rest.doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack
                                        ? "replace"
                                        : "assign";
                                case "go to auth server":
                                    return "assign";
                            }
                        })();
                        log === null || log === void 0 ? void 0 : log("redirectMethod: ".concat(redirectMethod));
                        extraQueryParams = (function () {
                            var e_2, _a;
                            var extraQueryParams = extraQueryParams_local !== null && extraQueryParams_local !== void 0 ? extraQueryParams_local : {};
                            read_query_params_added_by_transform_before_redirect: {
                                if (transformUrlBeforeRedirect_local === undefined) {
                                    break read_query_params_added_by_transform_before_redirect;
                                }
                                var url_afterTransform = void 0;
                                try {
                                    url_afterTransform = transformUrlBeforeRedirect_local("https://dummy.com");
                                }
                                catch (_b) {
                                    break read_query_params_added_by_transform_before_redirect;
                                }
                                try {
                                    for (var _c = __values(new URL(url_afterTransform).searchParams), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var _e = __read(_d.value, 2), name_2 = _e[0], value = _e[1];
                                        extraQueryParams[name_2] = value;
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                            return { extraQueryParams: extraQueryParams };
                        })().extraQueryParams;
                        return [4 /*yield*/, oidcClientTsUserManager.signinRedirect({
                                state: (0, tsafe_1.id)({
                                    context: "redirect",
                                    redirectUrl: redirectUrl,
                                    extraQueryParams: extraQueryParams,
                                    hasBeenProcessedByCallback: false,
                                    configId: configId,
                                    action: "login",
                                    redirectUrl_consentRequiredCase: (function () {
                                        switch (rest.action) {
                                            case "login":
                                                return lastPublicUrl !== null && lastPublicUrl !== void 0 ? lastPublicUrl : homeAndCallbackUrl;
                                            case "go to auth server":
                                                return redirectUrl;
                                        }
                                    })()
                                }),
                                redirectMethod: redirectMethod,
                                prompt: (function () {
                                    switch (rest.action) {
                                        case "go to auth server":
                                            return undefined;
                                        case "login":
                                            return rest.doForceInteraction ? "consent" : undefined;
                                    }
                                    tsafe_1.assert;
                                })(),
                                transformUrl: transformUrl_oidcClientTs
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function () { })];
                }
            });
        });
    }
    function toCallBeforeReturningOidcLoggedIn() {
        localStorage.removeItem(LOCAL_STORAGE_KEY_TO_CLEAR_WHEN_RETURNING_OIDC_LOGGED_IN);
    }
    function toCallBeforeReturningOidcNotLoggedIn() {
        var realPushState = history.pushState.bind(history);
        history.pushState = function pushState() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastPublicUrl = window.location.href;
            return realPushState.apply(void 0, __spreadArray([], __read(args), false));
        };
    }
    return {
        loginOrGoToAuthServer: loginOrGoToAuthServer,
        toCallBeforeReturningOidcLoggedIn: toCallBeforeReturningOidcLoggedIn,
        toCallBeforeReturningOidcNotLoggedIn: toCallBeforeReturningOidcNotLoggedIn
    };
}
//# sourceMappingURL=loginOrGoToAuthServer.js.map